module.exports = __webpack_public_path__ + "static/media/crackers.5ad90a86.svg";